import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";


export const loginService = async (data) => {
  return await HttpRequest.post(`${SERVER_URL}/team/login`, data);
};

export const profileService = async (token) => {
  return HttpRequest.get(`${SERVER_URL}/user/profile`, token);
};

export const logoutService = async (data) => {
  return await HttpRequest.post(`${SERVER_URL}/team/logout`, data);
};